/**
 * @generated SignedSource<<944c5b75fee02c6652b8c3fbfe08055a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RouteStatus = "DEGRADED" | "FAILED_TO_START" | "HEALTHY" | "PROVISIONING" | "TERMINATED" | "TERMINATING" | "UNHEALTHY" | "%future added value";
export type RouteTrafficStatus = "ACTIVE" | "INACTIVE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BAIRouteNodesFragment$data = ReadonlyArray<{
  readonly createdAt: string | null | undefined;
  readonly errorData: any | null | undefined;
  readonly id: string;
  readonly session: string | null | undefined;
  readonly status: RouteStatus;
  readonly trafficRatio: number;
  readonly trafficStatus: RouteTrafficStatus;
  readonly " $fragmentType": "BAIRouteNodesFragment";
}>;
export type BAIRouteNodesFragment$key = ReadonlyArray<{
  readonly " $data"?: BAIRouteNodesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BAIRouteNodesFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BAIRouteNodesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trafficRatio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorData",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "session",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trafficStatus",
      "storageKey": null
    }
  ],
  "type": "Route",
  "abstractKey": null
};

(node as any).hash = "b639d0cb3c07afc49bd87c6388dbcf6f";

export default node;
